const { SERVICE_AREAS } = require('./config/areas');
const { SEO_PAGES } = require('./config/seoPages');
const { MARICOPA_HOAS } = require('./config/hoas');
const { SITE_CONFIG } = require('./config');
const { SEO_CONFIG } = require('./config/seo');

const agent = SITE_CONFIG.AGENT.NAME;
const city = SEO_CONFIG.CITY;
const state = SEO_CONFIG.STATE;
const origin = SEO_CONFIG.DOMAIN.replace(/\/+$/, '');

const staticRoutes = [
  {
    url: '/first-fridays',
    title: 'Maricopa First Fridays | Downtown Heritage District',
    description: 'Explore Maricopa First Friday: food trucks, art, music, markets and classic cars in the Downtown Heritage District. October 2, 2026, 6–10 p.m.',
    priority: 0.7,
    changefreq: 'monthly',
    schemaType: 'WebPage',
    breadcrumb: 'Maricopa First Fridays'
  },
  {
    url: '/',
    title: `${agent} | ${city}, ${state} Real Estate Agent`,
    description: `Work with ${agent} for expert help buying or selling a home in ${city} and nearby ${state} communities.`,
    priority: 1,
    changefreq: 'weekly',
    schemaType: 'WebPage'
  },
  {
    url: '/agent',
    title: `About ${agent} | ${city} Real Estate Agent`,
    description: `Meet ${agent}, a ${city} real estate professional with ${SITE_CONFIG.AGENT.BROKERAGE_NAME} serving buyers and sellers across the region.`,
    priority: 0.8,
    changefreq: 'monthly',
    schemaType: 'AboutPage'
  },
  {
    url: '/contact-us',
    title: `Contact ${agent} | ${city} Real Estate`,
    description: `Contact ${agent} for help buying or selling real estate in ${city} and nearby ${state} communities.`,
    priority: 0.8,
    changefreq: 'monthly',
    schemaType: 'ContactPage'
  },
  {
    url: '/reviews',
    title: `Client Reviews | ${agent} Real Estate`,
    description: `Read client reviews and testimonials about working with ${agent} for ${state} real estate services.`,
    priority: 0.7,
    changefreq: 'weekly',
    schemaType: 'CollectionPage'
  },
  {
    url: '/blogs',
    title: `Real Estate Blog | ${agent}`,
    description: `Read real estate guidance, local market information, and home buying and selling tips from ${agent}.`,
    priority: 0.7,
    changefreq: 'weekly',
    schemaType: 'CollectionPage',
    prerender: false
  },
  {
    url: '/maricopa-hoas',
    title: `${city} HOA Directory and Fee Guide | ${agent}`,
    description: `Research ${city} HOA communities, management contacts, estimated assessments, transfer costs, and buyer due-diligence questions.`,
    priority: 0.8,
    changefreq: 'monthly',
    schemaType: 'CollectionPage'
  },
  {
    url: '/347-directory',
    title: `Maricopa AZ Business Directory | 347 Directory`,
    description: `Find restaurants, shops, home services, care providers, and other businesses serving ${city}, ${state} in the independent 347 Business Directory.`,
    priority: 0.8,
    changefreq: 'weekly',
    schemaType: 'CollectionPage',
    breadcrumb: '347 Directory'
  },
  {
    url: '/347-directory/setup',
    title: `347 Directory Setup & Maricopa Chamber App | ${agent}`,
    description: `Add or update your Maricopa business in Sandy Hopkins’ 347 Directory. Follow the setup steps, explore Chamber resources and download the community app.`,
    priority: 0.8,
    changefreq: 'monthly',
    schemaType: 'WebPage',
    breadcrumb: '347 Directory Setup',
    about: [
      { '@type': 'Thing', name: '347 Business Directory', url: `${origin}/347-directory` },
      { '@type': 'Organization', name: 'Greater Maricopa Business Alliance', alternateName: 'Maricopa Chamber of Commerce', url: 'https://www.maricopachamber.org/' }
    ]
  },
  {
    url: '/maricopa-app',
    title: `Download the Maricopa Chamber App | ${agent}`,
    description: `Download Community Clicker, the Maricopa Chamber of Commerce community app, for iPhone or Android.`,
    priority: 0.5,
    changefreq: 'yearly',
    schemaType: 'WebPage',
    static: true
  },
  {
    url: '/terms-of-service',
    title: `Terms of Service | ${agent} Real Estate`,
    description: `Terms governing use of the ${agent} real estate website and services.`,
    priority: 0.2,
    changefreq: 'yearly',
    schemaType: 'WebPage'
  },
  {
    url: '/privacy-policy',
    title: `Privacy Policy | ${agent} Real Estate`,
    description: `Privacy information for visitors to the ${agent} real estate website.`,
    priority: 0.2,
    changefreq: 'yearly',
    schemaType: 'WebPage'
  }
];

const areaRoutes = SERVICE_AREAS.map((area) => ({
  url: `/area/${area.slug}`,
  title: `${area.name} Homes for Sale | ${agent}`,
  description: `Explore ${area.name}, ${area.state} real estate and learn about the community with local guidance from ${agent}.`,
  priority: 0.8,
  changefreq: 'weekly',
  schemaType: 'WebPage',
  breadcrumb: area.name
}));

const guideRoutes = SEO_PAGES.map((page) => ({
  url: `/guide/${page.slug}`,
  title: page.title,
  description: page.description,
  priority: 0.8,
  changefreq: 'monthly',
  schemaType: 'Article',
  breadcrumb: page.h1
}));

const hoaRoutes = MARICOPA_HOAS.map((hoa) => ({
  url: `/maricopa-hoas/${hoa.slug}`,
  title: `${hoa.name} HOA Guide | ${agent}`,
  description: `Research the ${hoa.name} HOA in ${city}, ${state}, including management contacts, historical fee estimates, source links, and buyer questions.`,
  priority: 0.7,
  changefreq: 'monthly',
  schemaType: 'WebPage',
  breadcrumb: hoa.name
}));

const PUBLIC_ROUTES = [...staticRoutes, ...areaRoutes, ...guideRoutes, ...hoaRoutes];

const findPublicRoute = (pathname) => PUBLIC_ROUTES.find(({ url }) => url === pathname);

module.exports = { PUBLIC_ROUTES, findPublicRoute };
